// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__ChOUy","body":"NotFound_body__xqGvB","image":"NotFound_image__xcXCZ"};